module.exports = __webpack_public_path__ + "media/images/icons/instagram_black-5b1e3aab63496b4131db68f990b465a9.svg";